//jquery-autoloader
require('jquery');
require('jquery-autosize');
require('jquery-color');
require('jquery-cookie');
require('jquery-token-input');
require('jquery-truncate');
require('jquery-ui');

//backbone-autoloader
require('backbone-queryparams');
require('backbone-subset');

//backbone legacy adapter
require('skillshare/backbone-legacy-adapter');

require('bootstrap-tooltip');
require('underscore');
